import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { debounce } from '@helsenorge/designsystem-react/utils/debounce';
import Autosuggest from '@helsenorge/autosuggest/components/autosuggest';
import { useQuery } from '@helsenorge/core-utils/useQuery';
import { get } from '../page/utils';
const SearchAutosuggest = props => {
    const [suggestionQuery, setSuggestionQuery] = useState(props.query);
    const [debouncedSuggestionQuery, setDebouncedSuggestionQuery] = useState(props.query);
    useEffect(() => {
        const handleUpdate = async () => {
            setDebouncedSuggestionQuery(suggestionQuery);
        };
        const [debouncedUpdate, teardown] = debounce(handleUpdate, 500);
        debouncedUpdate();
        return () => {
            teardown();
        };
    }, [suggestionQuery]);
    const { data } = useQuery({
        queryKey: ['search', debouncedSuggestionQuery],
        args: [debouncedSuggestionQuery],
        queryFn: (signal, q) => get(`${props.searchUrl}autosuggest`, { q }, signal),
        staleTime: 30_000,
        enabled: !!debouncedSuggestionQuery,
    });
    const suggestions = data?.map(suggestion => ({
        label: suggestion,
        value: suggestion,
    }));
    const id = 'search-autosuggest';
    return (_jsx(Autosuggest, { id: id, shouldRenderSuggestions: () => props.shouldRenderSuggestions, inputProps: {
            type: 'search',
            name: 'query',
            'aria-label': props.inputAriaLabel,
            value: props.query,
            autoFocus: props.autoFocus,
            onChange: (_, params) => {
                if (params.method === 'type') {
                    setSuggestionQuery(params.newValue);
                }
                props.onChange(params.newValue);
            },
        }, containerProps: {
            'aria-label': props.containerAriaLabel,
            'aria-controls': `react-autowhatever-${id}`,
        }, suggestions: suggestions ?? [], onSuggestionSelected: (_e, data) => {
            props.onChange(data.suggestionValue);
            props.onSubmit(data.suggestionValue, 'autosuggest');
        }, onSuggestionsFetchRequested: () => {
            // Ikke nødvendig å gjøre noe her siden vi bruker useQuery.
        } }));
};
export default SearchAutosuggest;
